<template>
    <div class="pro_container">
        <!-- 头部 -->
        <v-header2></v-header2>
        <!-- 产品标题 -->
        <product-tool title="N1"></product-tool>
        <!-- 产品图片 -->
        <img class="pro_img" src="http://wx2.sinaimg.cn/large/0067mezugy1g5c4p7commj31hb0rsjsr.jpg"/>
        <img class="pro_img_mb" src="http://wx3.sinaimg.cn/large/0067mezugy1g5r003vgq0j30kw0rsq4l.jpg"/>
        <!-- 产品颜色切换效果 -->
        <div class="pro_animation">
            <swiper :options="swiperOption" v-if="seletedColor === 1">
                <!-- slides -->
                <swiper-slide v-for="(item, index) in earphones1" :key="index">
                    <div class="pro_animation_item"><img :src="item" /></div>
                </swiper-slide>
                <!-- Optional controls -->
                <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                <div class="swiper-button-next" slot="button-next"><i></i></div>
            </swiper>
            <swiper :options="swiperOption" v-else>
                <!-- slides -->
                <swiper-slide v-for="(item, index) in earphones2" :key="index">
                    <div class="pro_animation_item"><img :src="item" /></div>
                </swiper-slide>
                <!-- Optional controls -->
                <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                <div class="swiper-button-next" slot="button-next"><i></i></div>
            </swiper>
            <!-- 耳机颜色 -->
            <div class="pro_colors">
                简约灰 <i :class="{active: seletedColor == 0}" @click="switchColor(0)"></i>
                <i :class="{active: seletedColor == 1}" @click="switchColor(1)"></i> 深邃黑
            </div>
            <!-- <img src="http://wx3.sinaimg.cn/large/0067mezugy1g5c70sfwutj30l405dmxc.jpg" /> -->
            <ul class="pro_icons">
                <li v-for="(item, index) in iconList" :key="index">
                    <img :src="item.icon" />
                    <p>{{item.title}}</p>
                </li>
            </ul>
            <img class="pro_img_mb" src="http://wx4.sinaimg.cn/large/0067mezugy1g5r758dtxij30ku0a80tj.jpg"/>
        </div>
        <img class="pro_img" src="http://wx1.sinaimg.cn/large/0067mezugy1g5c7u2f63rj31hc0rsgn2.jpg"/>
        <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g5r004jlsej30kw0rsmza.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g5c7wqg242j31hc0rsq5a.jpg"/>
        <img class="pro_img_mb" src="http://wx2.sinaimg.cn/large/0067mezugy1g5r0051dhpj30kw0rsjtx.jpg"/>
        <img class="pro_img" src="http://wx2.sinaimg.cn/large/0067mezugy1g5c7ycj26rj31hc0rswfd.jpg"/>
        <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g5r005i92qj30kw0rsq40.jpg"/>
        <img class="pro_img" src="http://wx2.sinaimg.cn/large/0067mezugy1g5c7u2up1gj31hc0rs3zh.jpg"/>
        <img class="pro_img_mb" src="http://wx3.sinaimg.cn/large/0067mezugy1g5r006230lj30kw0rsdi2.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g5c7u3d02fj31hd0rs40s.jpg"/>
        <img class="pro_img_mb" src="http://wx3.sinaimg.cn/large/0067mezugy1g5r006prcxj30kw0rs0tw.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g5c7u3wcrij31hd0rsjsr.jpg"/>
        <img class="pro_img_mb" src="http://wx3.sinaimg.cn/large/0067mezugy1g5r0079xppj30kw0rswfe.jpg"/>
        <img class="pro_img" src="http://wx2.sinaimg.cn/large/0067mezugy1g5c7u4jdvmj31hc0rsmyb.jpg"/>
        <img class="pro_img_mb" src="http://wx4.sinaimg.cn/large/0067mezugy1g5r007oh24j30kw0rswgp.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g5c7u57unjj31hc0rsgn5.jpg"/>
        <img class="pro_img_mb" src="http://wx3.sinaimg.cn/large/0067mezugy1g5r758u2pwj30ku0rswi7.jpg"/>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g5c8c5bpwjj31hc0knmze.jpg"/>
        <v-footer2></v-footer2>
    </div>
</template>

<script>
import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper'
export default {
    components: {
        swiper,
        swiperSlide
    },
    data(){
        return {
            swiperOption: {
                // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                notNextTick: true,
                // swiper configs 所有的配置同swiper官方api配置
                autoplay: 3000,
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: true,
                pagination: '.swiper-pagination',
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
                paginationClickable: true,
                loop: true,
                // mousewheelControl : true,
                observeParents: true,
                // if you need use plugins in the swiper, you can config in here like this
                // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
                debugger: true,
            },
            seletedColor: 0,
            earphones1: ["http://wx1.sinaimg.cn/large/0067mezugy1g5c8ii1tgtj30c60e6q36.jpg", "http://wx3.sinaimg.cn/large/0067mezugy1g5c8iik6krj30ct0e5aab.jpg", "http://wx2.sinaimg.cn/large/0067mezugy1g5c8iizicoj30e60c8mxa.jpg"],
            earphones2: ["http://wx4.sinaimg.cn/large/0067mezugy1g5c8ijh02oj30bc0dndfz.jpg", "http://wx2.sinaimg.cn/large/0067mezugy1g5c8ik5ep9j30cs0e4wen.jpg", "http://wx1.sinaimg.cn/large/0067mezugy1g5c8ikm8k4j30eh0dfjrf.jpg"],
            iconList: [{
                icon: require("../../../assets/img/n/icon1.png"),
                title: "美国高通芯片"
            },{
                icon: require("../../../assets/img/n/icon2.png"),
                title: "蓝牙5.0标准"
            },{
                icon: require("../../../assets/img/n/icon3.png"),
                title: "CVC8.0降噪技术"
            },{
                icon: require("../../../assets/img/n/icon4.png"),
                title: "内置记忆钢丝颈挂"
            },{
                icon: require("../../../assets/img/n/icon5.png"),
                title: "双声道音频并行处理"
            },{
                icon: require("../../../assets/img/n/icon6.png"),
                title: "7小时无忧续航"
            },{
                icon: require("../../../assets/img/n/icon7.png"),
                title: "人体工学设计"
            },{
                icon: require("../../../assets/img/n/icon8.png"),
                title: "自动记忆配对蓝牙"
            },{
                icon: require("../../../assets/img/n/icon9.png"),
                title: "运动防汗"
            },{
                icon: require("../../../assets/img/n/icon10.png"),
                title: "轻若无物"
            }]
        }
    },
    methods:{
        switchColor(type){
            this.seletedColor = type;
        }
    }
}
</script>
<style scoped>

.pro_animation .pro_colors i:nth-child(1){
	background-image: url(../../../assets/img/n/pa_1.png);
}

.pro_animation .pro_colors i:nth-child(2){
	background-image: url(../../../assets/img/n/pa_2.png);
	margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/products/N/n1.vue